<template>
  <section class="hero is-background-light is-fullheight">
    <div class="hero-body">
      <div v-if="dataReady" class="container is-fluid">
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <article class="tile is-child is-light project-teaser">
              <p v-if="projects[0].externallink" class="title Rational-Bold">
                <a :href="projects[0].externallink" target="_blank">{{ projects[0].title }}</a>
              </p>
              <p v-else class="title Rational-Bold">{{ projects[0].title }}</p>
              <p class="subtitle Rational-Book">{{ projects[0].subtitle }}</p>
              <figure class="image">
                <div v-if="projects[0].agency != null" class="control client-info">
                  <div class="tags has-addons">
                    <span class="tag has-background-grey-lighter">Agency</span>
                    <span class="tag is-light">{{ projects[0].agency }}</span>
                  </div>
                </div>
                <a  v-if="projects[0].externallink" :href="projects[0].externallink" target="_blank">
                  <img :src="findThumbById(projects[0].teaserimage, '640x1000')" />
                </a>
                <img v-else :src="findThumbById(projects[0].teaserimage, '640x1000')" />
              </figure>
            </article>
          </div>
          <div class="tile is-vertical is-8">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child is-light project-teaser">
                  <p class="title Rational-Bold">{{ projects[1].title }}</p>
                  <p class="subtitle Rational-Book">{{ projects[1].subtitle }}</p>
                  <figure class="image">
                    <div v-if="projects[1].agency != null" class="control client-info">
                      <div class="tags has-addons">
                        <span class="tag has-background-grey-lighter">Agency</span>
                        <span class="tag is-light">{{ projects[1].agency }}</span>
                      </div>
                    </div>
                    <img :src="findThumbById(projects[1].teaserimage, '640x360')" />
                  </figure>
                </article>
                <article class="tile is-child is-light project-teaser">
                  <p class="title Rational-Bold">{{ projects[2].title }}</p>
                  <p class="subtitle Rational-Book">{{ projects[2].subtitle }}</p>
                  <figure class="image">
                    <div v-if="projects[2].agency != null" class="control client-info">
                      <div class="tags has-addons">
                        <span class="tag has-background-grey-lighter">Agency</span>
                        <span class="tag is-light">{{ projects[2].agency }}</span>
                      </div>
                    </div>
                    <img :src="findThumbById(projects[2].teaserimage, '640x360')" />
                  </figure>
                </article>
              </div>
              <div class="tile is-parent is-vertical">
                <article class="tile is-child is-light project-teaser">
                  <p class="title Rational-Bold">{{ projects[3].title }}</p>
                  <p class="subtitle Rational-Book">{{ projects[3].subtitle }}</p>
                  <figure class="image">
                    <div v-if="projects[3].agency != null" class="control client-info">
                      <div class="tags has-addons">
                        <span class="tag has-background-grey-lighter">Agency</span>
                        <span class="tag is-light">{{ projects[3].agency }}</span>
                      </div>
                    </div>
                    <img :src="findThumbById(projects[3].teaserimage, '640x360')" />
                  </figure>
                </article>

                <article class="tile is-child is-light project-teaser">
                  <p class="title Rational-Bold">{{ projects[4].title }}</p>
                  <p class="subtitle Rational-Book">{{ projects[4].subtitle }}</p>
                  <figure class="image">
                    <div v-if="projects[4].agency != null" class="control client-info">
                      <div class="tags has-addons">
                        <span class="tag has-background-grey-lighter">Agency</span>
                        <span class="tag is-light">{{ projects[4].agency }}</span>
                      </div>
                    </div>
                    <img :src="findThumbById(projects[4].teaserimage, '640x360')" />
                  </figure>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <h1>Loading ...</h1>
      </div>
    </div>
  </section>
</template>


<script>
import { mapState } from 'vuex';

export default {
  name: 'Projects',
  props: {},
  data() {
    return {
      dataReady: false,
    };
  },
  methods: {
    findThumbById(id, size) {
      const found = this.projectThumbnails.find(element => element.id === id);
      // console.log(found);
      const thumb = found.data.thumbnails.find(
        element => element.dimension === size,
      );
      // console.log(thumb);
      const bestThumb = thumb.url.replace('/good/', '/best/');
      // console.log(bestThumb);
      return bestThumb;
    },
  },
  computed: {
    ...mapState(['projects', 'projectThumbnails']),
  },
  async mounted() {
    await this.$store.dispatch('UPDATE_PROJECTS');
    await this.$store.dispatch('UPDATE_PROJECTTHUMBNAILS');
    this.dataReady = true;
  },
};
</script>

<style scoped>
.client-info {
  position: absolute;
  bottom: 10px;
  left: 10px;
}
.project-teaser {
  padding-bottom: 48px !important;
}
</style>
